import styled from 'styled-components';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  box-shadow: 1px 1px 0 0 rgba(11, 37, 80, 0.17);
  border: 1px solid ${({ theme }) => theme.color.grey200};
`;

export const TableStyled = styled.table`
  width: 100%;
  border-radius: 12px;
  border-collapse: separate;

  > thead {
    tr {
      th {
        vertical-align: middle;
        text-align: start;
        padding: 12px 24px;
        color: ${({ theme }) => theme.color.grey600};
        font-size: 14px;
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0.07px;
        background: ${({ theme }) => theme.color.grey50};
        border-bottom: 1px solid ${({ theme }) => theme.color.grey200};

        span {
          white-space: nowrap;
        }

        &.patient-column .professional-column {
          width: 50%;
        }
        &.phone-column {
          max-width: 200px;
          min-width: 200px;
          width: 200px;
        }
        &.date-column {
          max-width: 320px;
          min-width: 320px;
          width: 320px;
        }
        &:last-of-type {
          max-width: 140px;
          min-width: 140px;
          width: 140px;
          text-align: center;
        }
      }
    }
  }
  > tbody {
    > tr {
      &:last-child {
        > td {
          &:first-child {
            border-bottom-left-radius: 12px;
          }
          &:last-child {
            border-bottom-right-radius: 12px;
          }
        }
      }
    }

    .noResults {
      text-align: center;
      padding: 16px;
    }
  }
`;
